import {QueryStartEvent, WorkflowComplete} from 'common/util/workflow-timing';

import type {InsightsApp} from '../insights-app';

export const insightsQueryStartedWorkflowComplete: WorkflowComplete<InsightsApp> = ({detail}) => {
  return detail.eventName === QueryStartEvent;
};
